import { Link } from 'react-router-dom';
import styles from '../styles/NotFound.module.css';

function NotFound() {
    return (
        <div className={styles.notFound}>
            <h1>404</h1>
            <p>Page not found</p>
            <Link to="/" className={styles.homeLink}>
                Go back home
            </Link>
        </div>
    );
}

export default NotFound;
